import quickSpecs from './quickSpecs';
import vehicleType from './vehicleType';

const root = {
	quickSpecs,
	vehicleType
};

export default root;
